// Numeric constants
export const ACTUAL_INDEX = 1;
export const LAST_ATTEMPT_INDEX = 1;
export const SINGLE_RECORD = 1;
export const REDUCE_TIMEOUT = 0;
export const FIRST_ELEMENT = 0;
export const TOOLTIP_TIMEOUT = 150;

// Section identifiers
export const SECTION_BASIC_INFO = "basicInfo";
export const SECTION_CORRECTIVE_ACTION = "correctiveAction";

// Redirect paths
export const REDIRECT_PATHS = {
  exception: "/exception-list",
  transit: "/in-transit-list",
};
